import { Dropdown, DropdownItem, DropdownMenu } from 'semantic-ui-react';

import { Icon, Text } from '@britishcouncil/react-admin';
import { generatePath, useLocation, useNavigate } from 'react-router';
import { ROUTING_PATHS } from 'const';

export type SpeakingSessionOptionsMenuProps = {
  sessionId: number;
  canEdit: boolean;
  canRemove: boolean;
};

export const SpeakingSessionOptionsMenu = ({
  sessionId,
  canEdit,
  canRemove,
}: SpeakingSessionOptionsMenuProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { removeSpeakingSession, editSpeakingSession } = ROUTING_PATHS;
  const canDisplayOptions = canEdit || canRemove;

  if (!canDisplayOptions) {
    return null;
  }

  return (
    <Dropdown icon={{ name: 'ellipsis vertical', color: 'blue' }} data-testid="session-options">
      <DropdownMenu direction="left">
        {canEdit && (
          <DropdownItem
            data-testid="edit-session"
            onClick={() => {
              void navigate(generatePath(editSpeakingSession.absolutePath, { sessionId }), {
                state: location.state,
              });
            }}
          >
            <Icon name="pen square" color="blue" />
            <Text color="blue">Edit</Text>
          </DropdownItem>
        )}
        {canRemove && (
          <DropdownItem
            data-testid="remove-session"
            onClick={() => {
              void navigate(generatePath(removeSpeakingSession.absolutePath, { sessionId }), {
                state: location.state,
              });
            }}
          >
            <Icon name="trash alternate" color="red" />
            <Text color="red">Remove</Text>
          </DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};
